$(document).ready(function(){
$('.custom-collection-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev"><svg width="14" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.658964 13.1467L11.9544 23.9091C12.1428 24.0887 12.3932 24.189 12.6536 24.189C12.914 24.189 13.1644 24.0887 13.3529 23.9091L13.365 23.8969C13.4567 23.8098 13.5297 23.705 13.5796 23.5888C13.6295 23.4726 13.6552 23.3474 13.6552 23.221C13.6552 23.0945 13.6295 22.9694 13.5796 22.8532C13.5297 22.737 13.4567 22.6321 13.365 22.545L2.72834 12.411L13.365 2.28098C13.4567 2.19388 13.5297 2.08904 13.5796 1.97284C13.6295 1.85664 13.6552 1.7315 13.6552 1.60504C13.6552 1.47858 13.6295 1.35344 13.5796 1.23724C13.5297 1.12104 13.4567 1.0162 13.365 0.929098L13.3529 0.916937C13.1644 0.73727 12.914 0.637043 12.6536 0.637043C12.3932 0.637043 12.1428 0.73727 11.9544 0.916937L0.658964 11.6793C0.559625 11.7739 0.48054 11.8878 0.426504 12.0139C0.372468 12.14 0.344604 12.2758 0.344604 12.413C0.344604 12.5502 0.372468 12.686 0.426504 12.8121C0.48054 12.9382 0.559625 13.0521 0.658964 13.1467Z" fill="black"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="14" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0179 13.1467L1.7225 23.9091C1.53403 24.0887 1.28364 24.189 1.02325 24.189C0.762866 24.189 0.512473 24.0887 0.324004 23.9091L0.311842 23.8969C0.220159 23.8098 0.147154 23.705 0.0972672 23.5888C0.0473795 23.4726 0.0216532 23.3474 0.0216532 23.221C0.0216532 23.0945 0.0473795 22.9694 0.0972672 22.8532C0.147154 22.737 0.220159 22.6321 0.311842 22.545L10.9485 12.411L0.311842 2.28098C0.220159 2.19388 0.147154 2.08904 0.0972672 1.97284C0.0473795 1.85664 0.0216532 1.7315 0.0216532 1.60504C0.0216532 1.47858 0.0473795 1.35344 0.0972672 1.23724C0.147154 1.12104 0.220159 1.0162 0.311842 0.929098L0.324004 0.916937C0.512473 0.73727 0.762866 0.637043 1.02325 0.637043C1.28364 0.637043 1.53403 0.73727 1.7225 0.916937L13.0179 11.6793C13.1173 11.7739 13.1963 11.8878 13.2504 12.0139C13.3044 12.14 13.3323 12.2758 13.3323 12.413C13.3323 12.5502 13.3044 12.686 13.2504 12.8121C13.1963 12.9382 13.1173 13.0521 13.0179 13.1467Z" fill="black"/></svg></button>',

  responsive: [
      {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 820,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

  $('.custom-testimonial').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
   prevArrow: '<button type="button" class="slick-prev"><svg width="14" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.658964 13.1467L11.9544 23.9091C12.1428 24.0887 12.3932 24.189 12.6536 24.189C12.914 24.189 13.1644 24.0887 13.3529 23.9091L13.365 23.8969C13.4567 23.8098 13.5297 23.705 13.5796 23.5888C13.6295 23.4726 13.6552 23.3474 13.6552 23.221C13.6552 23.0945 13.6295 22.9694 13.5796 22.8532C13.5297 22.737 13.4567 22.6321 13.365 22.545L2.72834 12.411L13.365 2.28098C13.4567 2.19388 13.5297 2.08904 13.5796 1.97284C13.6295 1.85664 13.6552 1.7315 13.6552 1.60504C13.6552 1.47858 13.6295 1.35344 13.5796 1.23724C13.5297 1.12104 13.4567 1.0162 13.365 0.929098L13.3529 0.916937C13.1644 0.73727 12.914 0.637043 12.6536 0.637043C12.3932 0.637043 12.1428 0.73727 11.9544 0.916937L0.658964 11.6793C0.559625 11.7739 0.48054 11.8878 0.426504 12.0139C0.372468 12.14 0.344604 12.2758 0.344604 12.413C0.344604 12.5502 0.372468 12.686 0.426504 12.8121C0.48054 12.9382 0.559625 13.0521 0.658964 13.1467Z" fill="black"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="14" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0179 13.1467L1.7225 23.9091C1.53403 24.0887 1.28364 24.189 1.02325 24.189C0.762866 24.189 0.512473 24.0887 0.324004 23.9091L0.311842 23.8969C0.220159 23.8098 0.147154 23.705 0.0972672 23.5888C0.0473795 23.4726 0.0216532 23.3474 0.0216532 23.221C0.0216532 23.0945 0.0473795 22.9694 0.0972672 22.8532C0.147154 22.737 0.220159 22.6321 0.311842 22.545L10.9485 12.411L0.311842 2.28098C0.220159 2.19388 0.147154 2.08904 0.0972672 1.97284C0.0473795 1.85664 0.0216532 1.7315 0.0216532 1.60504C0.0216532 1.47858 0.0473795 1.35344 0.0972672 1.23724C0.147154 1.12104 0.220159 1.0162 0.311842 0.929098L0.324004 0.916937C0.512473 0.73727 0.762866 0.637043 1.02325 0.637043C1.28364 0.637043 1.53403 0.73727 1.7225 0.916937L13.0179 11.6793C13.1173 11.7739 13.1963 11.8878 13.2504 12.0139C13.3044 12.14 13.3323 12.2758 13.3323 12.413C13.3323 12.5502 13.3044 12.686 13.2504 12.8121C13.1963 12.9382 13.1173 13.0521 13.0179 13.1467Z" fill="black"/></svg></button>',

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 840,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

// code for the tab in the homepage
 $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

  // code for blog section on home page
$('.articles-wrapper').slick({
  infinite: true,
  slidesToShow: 2,
  speed: 300,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="slick-prev"><svg width="14" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.658964 13.1467L11.9544 23.9091C12.1428 24.0887 12.3932 24.189 12.6536 24.189C12.914 24.189 13.1644 24.0887 13.3529 23.9091L13.365 23.8969C13.4567 23.8098 13.5297 23.705 13.5796 23.5888C13.6295 23.4726 13.6552 23.3474 13.6552 23.221C13.6552 23.0945 13.6295 22.9694 13.5796 22.8532C13.5297 22.737 13.4567 22.6321 13.365 22.545L2.72834 12.411L13.365 2.28098C13.4567 2.19388 13.5297 2.08904 13.5796 1.97284C13.6295 1.85664 13.6552 1.7315 13.6552 1.60504C13.6552 1.47858 13.6295 1.35344 13.5796 1.23724C13.5297 1.12104 13.4567 1.0162 13.365 0.929098L13.3529 0.916937C13.1644 0.73727 12.914 0.637043 12.6536 0.637043C12.3932 0.637043 12.1428 0.73727 11.9544 0.916937L0.658964 11.6793C0.559625 11.7739 0.48054 11.8878 0.426504 12.0139C0.372468 12.14 0.344604 12.2758 0.344604 12.413C0.344604 12.5502 0.372468 12.686 0.426504 12.8121C0.48054 12.9382 0.559625 13.0521 0.658964 13.1467Z" fill="black"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="14" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0179 13.1467L1.7225 23.9091C1.53403 24.0887 1.28364 24.189 1.02325 24.189C0.762866 24.189 0.512473 24.0887 0.324004 23.9091L0.311842 23.8969C0.220159 23.8098 0.147154 23.705 0.0972672 23.5888C0.0473795 23.4726 0.0216532 23.3474 0.0216532 23.221C0.0216532 23.0945 0.0473795 22.9694 0.0972672 22.8532C0.147154 22.737 0.220159 22.6321 0.311842 22.545L10.9485 12.411L0.311842 2.28098C0.220159 2.19388 0.147154 2.08904 0.0972672 1.97284C0.0473795 1.85664 0.0216532 1.7315 0.0216532 1.60504C0.0216532 1.47858 0.0473795 1.35344 0.0972672 1.23724C0.147154 1.12104 0.220159 1.0162 0.311842 0.929098L0.324004 0.916937C0.512473 0.73727 0.762866 0.637043 1.02325 0.637043C1.28364 0.637043 1.53403 0.73727 1.7225 0.916937L13.0179 11.6793C13.1173 11.7739 13.1963 11.8878 13.2504 12.0139C13.3044 12.14 13.3323 12.2758 13.3323 12.413C13.3323 12.5502 13.3044 12.686 13.2504 12.8121C13.1963 12.9382 13.1173 13.0521 13.0179 13.1467Z" fill="black"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// replace the view as text on shop page 
  setTimeout(function() {
    $(".boost-sd__view-as-text").each(function() { 
        const text = $(this).text();
        if (text.includes("View as")) {
            $(this).text(text.replace("View as", "View: "));
        }
    });
}, 1000); 
 
});


 

